import types from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case types.GET_TASK:
      return action.task || {};
    case types.LOGOUT:
      return {};
    default:
      return state;
  }
};
